'use client';

import { usePathname } from 'next/navigation';
import { useUser } from '@/app_lib/providers/UserProvider';

const ARTICLE_PATH_PATTERNS = [
  { pattern: /^\/\d{4}\/\d{2}\/\d{2}\//, reason: 'standard /YYYY/MM/DD/SLUG/' },
  { pattern: /^\/article\/[^/]+\/?$/, reason: '/article/slug' },
  { pattern: /^\/(?:europe|asia|well|crypto)\/\d{4}\/\d{2}\/\d{2}\//, reason: 'legacy section prefixed' },
  { pattern: /^\/(?:europe|asia|well|crypto)\/article\/[^/]+\/?$/, reason: '/<section>/article/slug' },
] as const;

export function useIsMobileAppArticle(): boolean {
  const { isMobileApp } = useUser();
  const pathname = usePathname() ?? '';
  return isMobileApp && ARTICLE_PATH_PATTERNS.some(({ pattern }) => pattern.test(pathname));
}
